/**
 * href からスクロール先の要素を取得
 *   * 「#1234」のように数字から始まる id は querySelector で構文エラーになるため、getElementById で取得する
 */
const getScrollTarget = (href: string): HTMLElement | null => {
    if(href==='#' || href==='') return document.documentElement
    try {
        if(/^#[^\s.#:>+~[\],]+$/.test(href)) {
            return document.getElementById(decodeURIComponent(href.slice(1)))
        }
        return document.querySelector<HTMLElement>(href)
    }
    catch {
        return null
    }
}

/**
 * ページ内リンクのスムーススクロール制御
 */
export const initSmoothScroll = (): void => {
    const anchorLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]')
    anchorLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href')
            if(!href) return

            const target = getScrollTarget(href)
            if(target) {
                e.preventDefault()
                target.scrollIntoView({ behavior: 'smooth' })
            }
        })
    })
}
